import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const useRouteState = () => {
    const { pathname } = useLocation()

    const currentTab = useMemo(() => {
        if (pathname.includes('/brands')) return 'brands'
        if (pathname.includes('/campaigns')) return 'campaigns'
        if (pathname.includes('/number-assignement')) return 'number-assignement'

        return ''
    }, [pathname])

    const activePage = useMemo(() => {
        if (pathname.endsWith('/create')) return 'create'
        if (pathname.endsWith('/edit')) return 'edit'
        if (pathname.endsWith('/preview')) return 'preview'

        return 'list'
    }, [pathname])

    return {
        currentTab,
        activePage
    }
}

export default useRouteState
